// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/notice-bar/style/index.less
// module id = 188
// module chunks = 0